export default {
  getProductListing: {
    url: '/product/getProductListing',
    method: 'post',
    desc: '获取listing维度概览'
  },
  getListingProductList: {
    url: '/listing/getListingProductList',
    method: 'post',
    desc: '获取商品表现分析商品列表'
  },
  getListingProductFollowList: {
    url: '/listing/getListingProductFollowList',
    method: 'post',
    desc: '获取商品表现分析商品关注列表'
  },
  addListingProductFollow: {
    url: '/listing/addListingProductFollow',
    method: 'post',
    desc: '添加商品表现分析商品关注'
  },
  cancelListingProductFollow: {
    url: '/listing/cancelListingProductFollow',
    method: 'post',
    desc: '取消商品表现分析商品关注'
  },
  getProductDetail: {
    url: '/product/getProductDetail',
    method: 'post',
    desc: '获取商品信息'
  },
  getListingCalendar: {
    url: '/product/getListingCalendar',
    method: 'post',
    desc: '获取Listing日历列表'
  },
  addsListingLogs: {
    url: '/product/addsListingLogs',
    method: 'post',
    desc: '添加Listing运营日志'
  },
  updateListingLogs: {
    url: '/product/updateListingLogs',
    method: 'post',
    desc: '修改listing运营日志'
  },
  delListingLogs: {
    url: '/product/delListingLogs',
    method: 'post',
    desc: '删除listing运营日志'
  },
  getListingLogList: {
    url: '/product/getListingLogList',
    method: 'post',
    desc: 'listing运营日志列表'
  },
  getProductAsinList: {
    url: '/product/getProductAsinList',
    method: 'post',
    desc: '获取商品Asin列表'
  },
  getListingCalendarDay: {
    url: '/product/getListingCalendarDay',
    method: 'post',
    desc: 'Listing日历日志（天）列表'
  },
  saveProductListingRemark: {
    url: '/product/saveProductListingRemark',
    method: 'post',
    desc: '商品表现分析设置备注'
  },
  getListingLogOverview: {
    url: '/product/getListingLogOverview',
    method: 'post',
    desc: '获取Listing日历日志概览列表'
  },
  getParentAsinAnalyzeDetail: {
    url: '/listing/getParentAsinAnalyzeDetail',
    method: 'post',
    desc: '获取Listing分析父ASIN基础信息'
  },
  getParentAsinAnalyzeContrast: {
    url: '/listing/getParentAsinAnalyzeContrast',
    method: 'post',
    desc: '获取Listing分析父ASIN对比信息'
  },
  getParentAsinAnalyzeSummary: {
    url: '/listing/getParentAsinAnalyzeSummary',
    method: 'post',
    desc: '获取Listing分析父ASIN汇聚信息'
  },
  getProductListingShipmentTransfer: {
    url: '/product/getProductListingShipmentTransfer',
    method: 'post',
    desc: '获取商品表现-FBA货件'
  },
}
